import React, { useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { Container, Card, CardBody } from 'reactstrap';
import agent from '../../agent';
import { toJobSearchJobDetail, toBrowseJobsByState } from '../../routes';
import {
  positionCodeToDisplayName,
  specialtyOptions,
  stateOptions,
} from '../../utils/displayHelper';
import JobPostingView from '../../components/job-postings/JobPostingView';
import { excludedSpecialties } from '../../utils/displayHelper';
import { JobPostingCSVJobType } from '../../types/csv';
import { JobViewType, PartnerJobViewType } from '../../types/services-api';
import { useContext, useState } from 'react';
import { formatJobViewTracking } from '../../utils/mixpanelEventHelper';
import { UserContext } from '../../context/UserContext';
import { ProfileContext } from '../../context/ProfileContext';
import { GlobalContext } from '../../context/GlobalContext';

const formatString = (string) =>
  string?.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const Job = (props: {
  //either a statically generated job page or a dynamically redirected job
  job: JobPostingCSVJobType | JobViewType | PartnerJobViewType;
  indexCity?: {
    city: string;
    state: string;
  };
  indexMsa?: {
    shortName: string;
  };
  isDynamic: boolean;
}) => {
  const { user } = useContext(UserContext);
  const { profile } = useContext(ProfileContext);
  const [hasMounted, setHasMounted] = useState(false);
  const indexCity = props.indexCity;
  const indexMsa = props.indexMsa;
  const {
    userAuth: { isAuthenticated },
  } = useContext(GlobalContext);
  const job = props.job;
  const jobId = 'jobId' in job ? job.jobId : job.jobKey;
  const state = 'jobId' in job ? job.state : stateOptions[job.state];

  const isDynamic = props.isDynamic;

  //const isInternal =
  const position = isDynamic
    ? job.position
    : positionCodeToDisplayName[job.position];
  const updatedPosition = `${
    'specialty' in job && !excludedSpecialties.includes(job.specialty)
      ? `${specialtyOptions[job.specialty] || job.specialty}`
      : ''
  } ${position}`;

  useEffect(() => {
    if (isAuthenticated) {
      navigate(toJobSearchJobDetail(jobId));
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (hasMounted) {
      agent.Jobs.view({ jobId: jobId })
        .then((res) => {
          formatJobViewTracking(job, user, profile);
          return;
        })
        .catch((err) => console.log(err.message));
    }
  }, [hasMounted]);

  return (
    <>
      <div className="jumbotron bg-secondary text-white text-center py-5">
        <p className="h1">{`${updatedPosition} Job Posting`}</p>
      </div>
      <Container>
        <div className="mb-2">
          <Link to={toBrowseJobsByState}>All Job Postings</Link>
          &nbsp;&gt;&nbsp;
          <Link to={`/dental-jobs/${formatString(state)}-dental-jobs/`}>
            {state}
          </Link>
          &nbsp;&gt;&nbsp;
          {indexMsa && (
            <>
              <Link
                to={`/dental-jobs/${formatString(
                  indexMsa.shortName
                )}-dental-jobs/`}
              >
                {indexMsa.shortName}
              </Link>
              &nbsp;&gt;&nbsp;
              <Link
                to={`/dental-jobs/${formatString(
                  indexMsa.shortName
                )}-${formatString(position)}-jobs/`}
              >
                {position}
              </Link>
            </>
          )}
          {!indexMsa && (
            <>
              <Link
                to={`/dental-jobs/${formatString(state)}-${
                  position === 'LT' ? 'dental-lab-tech' : formatString(position)
                }-jobs/`}
              >
                {position}
              </Link>
            </>
          )}
          &nbsp;&gt;&nbsp;
          {`${updatedPosition} Job (ID: ${jobId})`}
        </div>

        <Card className="mb-3">
          <CardBody>
            <JobPostingView
              jobData={props.job}
              listing={
                indexCity
                  ? `/dental-jobs/jobs-near-${formatString(
                      indexCity.city
                    )}-${formatString(indexCity.state)}/`
                  : `/dental-jobs/${formatString(
                      indexMsa?.shortName || state
                    )}-${formatString(position)}-jobs/`
              }
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Job;
